<template>
    <span
        v-if="value"
        :title="value"
        class="weathericon"
    >
        <component :is="componentName" />
    </span>
</template>
<script lang="ts" setup>
import type { WeatherTypes } from '@/objects/generated';

const props = defineProps<{
    /**
     * The name of the icon to display
     */
    value: WeatherTypes | null;

    /**
     * If it is night time. We switch to night icons then
     */
    isnight?: boolean;
}>();

const componentName = props.value ? `WeatherIcon${props.value}${props.isnight === true ? '_night' : ''}` : null;
</script>
